import React, { useLayoutEffect, useState } from 'react';
import { Router } from 'react-router-dom';

/**
 * A v7-compatible wrapper
 */
function HistoryRouter({ history, children }) {
  const [state, setState] = useState({
    action: history.action || 'POP',
    location: history.location,
  });

  useLayoutEffect(() => {
    return history.listen((update) => {
      const nextLocation = update.location || update;
      const nextAction = update.action || 'PUSH';

      setState({
        action: nextAction,
        location: nextLocation,
      });
    });
  }, [history]);

  return (
    <Router
      navigationType={state.action}
      location={state.location}
      navigator={history}
    >
      {children}
    </Router>
  );
}

export default HistoryRouter;
